import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { getToken, ManageCategory, ManageRestaurant, showMessage } from "../../Functionalities/Functions";
import AddProduct from "../Products/AddProduct";
import EditTopComponent from '../../CoreComponents/EditTopComponent'
import EditBottomComponent from '../../CoreComponents/EditBottomComponent'
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import ModalComponent from "../../CoreComponents/FilterModalComponent";
import ModalFilterComponent from "../PromoCode/Component/ModalFilterComponent";
import { is_franchise_admin, is_franchise_manager, is_superuser, protocol, url } from "../../Functionalities/Config";
import axios from "axios";
import { ManageInnerCategory } from "./Logic";



function Body(props) {
  const [data, setData] = useState({
    id: "",
    name: "",
    bg_image: "",
    icon: "",
    is_active: "",
    is_blocked: false,
    inner_category: ""
  });
  const [Edit, setEdit] = useState(props.id == "add" ? true : false);
  const [noCat, setNoCat] = useState(false)
  const [loading, setloading] = useState(true)
  const [search, setSearch] = useState("")
  const [products, setProducts] = useState([])
  const [allProducts, setAllProducts] = useState([])
  const [addProductPrev, setAddProductPrev] = useState("")
  const [addProductNext, setAddProductNext] = useState("")
  const [menuUpdate, setMenuUpdate] = useState(false)
  const [saveEdit, setsaveEdit] = useState(false)
  const arr = [1, 1, 1]



  // void 0
  useEffect(() => {
    getBranches()
    getCategories()

    let id = props.id;
    // void 0
    let Catdata = ManageInnerCategory("", "", "get", `id=${id}`);
    Catdata.then((cat) => {
      if (cat.data.results.length) {
        setData({
          ...data,
          id: cat.data.results[0].id,
          name: cat.data.results[0].name,
          bg_image:
            cat.data.results[0].bg_image && cat.data.results[0].bg_image.image,
          icon: cat.data.results[0].icon && cat.data.results[0].icon.image,
          is_active: cat.data.results[0].is_active,
          is_blocked: cat.data.results[0].is_blocked,
          inner_category: cat.data.results[0].inner_category,
        });
        setloading(false)
      }
      else {
        setNoCat(true)
        setloading(false)
      }

      // void 0
    });

  }, []);

  useEffect(() => {
    getProducts()
  }, [menuUpdate])

  const [categories, setcategories] = useState([])
  const [branch, setBranch] = useState([])

  const [filter, setfilter] = useState({
    branch_id: "",
    category_id: "",
    search_text: "",
    search_id: ""
  })

  const [addFilter, setAddfilter] = useState({
    branch_id: "",
    category_id: "",
    search_text: "",
    search_id: ""
  })

  const getProducts = () => {
    let params = "?inner_category_id=" + props.id;

    if (filter.branch_id != "") {
      params = params + "&branch_id=" + filter.branch_id
    }
    if (filter.search_text != "") {
      params = params + "&search_text=" + filter.search_text
    }
    if (filter.search_id != "") {
      params = params + "&id=" + filter.search_id
    }

    var config = {
      method: 'get',
      url: url + '/items/details/' + params,
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        setProducts(response.data.results)
        setNext(response.data.next)
        setPrev(response.data.prev)
      })
      .catch(function (error) {
      });
  }

  const getCategories = () => {
    let params = "for_dropdown=true&page_wise=false";

    var config = {
      method: "get",
      url: url + "/items/category/?" + params,
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setcategories(response.data);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const [next, setNext] = useState("")
  const [prev, setPrev] = useState("")


  const getBranches = () => {

    let params = "for_dropdown=true&page_wise=false&order_by_name=true";

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        setBranch(result.data)
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");

    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace('//', "")),
      // url: prev + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setProducts(response.data.results)
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    // alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace('//', "")),
      // url: next + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    axios(config)
      .then(function (response) {
        setProducts(response.data.results)
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleProductPrev = () => {
    var config = {
      method: "get",
      url: addProductPrev.replace("http:", protocol.replace('//', "")),
      // url: prev + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setAllProducts(response.data.results)
        setAddProductNext(response.data.next);
        setAddProductPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleProductNext = () => {
    // alert("next")
    var config = {
      method: "get",
      url: addProductNext.replace("http:", protocol.replace('//', "")),
      // url: next + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    axios(config)
      .then(function (response) {
        setAllProducts(response.data.results)
        setAddProductNext(response.data.next);
        setAddProductPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleSearchProducts = () => {
    getProducts()
  }

  const clearSearchProducts = () => {
    setfilter({ branch_id: "", search_id: "", search_text: "" })
    var config = {
      method: 'get',
      url: url + '/items/details/?inner_category_id=' + props.id,
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        setProducts(response.data.results)
        setNext(response.data.next)
        setPrev(response.data.prev)
      })
      .catch(function (error) {
      });
  }

  const handleSearch = () => {
    let params = "?inner_category_id=" + props.id + "&not_included_items=true";
    if (addFilter.branch_id != "") {
      if (params == "") {
        params = "?branch_id=" + addFilter.branch_id
      } else {
        params = params + "&branch_id=" + addFilter.branch_id
      }
    }
    if (addFilter.search_text != "") {
      if (params == "") {
        params = "?search_text=" + addFilter.search_text
      } else {
        params = params + "&search_text=" + addFilter.search_text

      }
    }
    if (addFilter.search_id != "") {
      if (params == "") {
        params = "?id=" + addFilter.search_id
      } else {
        params = params + "&id=" + addFilter.search_id

      }
    }


    var config = {
      method: 'get',
      url: url + '/items/details/' + params,
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        setAllProducts(response.data.results)
        setAddProductNext(response.data.next);
        setAddProductPrev(response.data.previous);
      })
      .catch(function (error) {
      });
  }


  // const imageChange = (e) => {
  //     const reader = new FileReader();
  //     reader.addEventListener("load", () => {
  //         setData({ ...data, backgroundimage: reader.result });

  //     })
  //     reader.readAsDataURL(e.target.files[0]);
  // }
  // const imageChange1 = (e) => {
  //     const reader = new FileReader();
  //     reader.addEventListener("load", () => {
  //         setData({ ...data, icon: reader.result });

  //     })
  //     reader.readAsDataURL(e.target.files[0]);
  // }
  const submitHandler = (e) => {
    e.preventDefault();
    // void 0
  };

  const [errors, setErrors] = useState([]);

  const addProduct = (itemId) => {
    var data = new FormData();
    data.append('keyword', 'add_inner_cat_product');
    data.append('item_id', itemId);
    data.append('inner_category_id', props.id);

    var config = {
      method: 'patch',
      url: url + '/items/details/',
      headers: {
        'Authorization': getToken(),
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status == true) {
          showMessage("Product added to menu", "success", "Success!", 'top', 'top-right', 0)
          setMenuUpdate(!menuUpdate)
          handleSearch()
        } else {
          showMessage("Menu update failed", "danger", "Error!", 'top', 'top-right', 0)
        }
      })
      .catch(function (error) {
        showMessage("Menu update failed", "danger", "Error!", 'top', 'top-right', 0)
      });
  }

  const removeProduct = (itemId) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui' style={{ borderRadius: 8, border: 'solid', padding: 70, borderWidth: 0.5 }}>
            <h1>Are you sure?</h1>
            <p>Press remove to remove this product from menu</p>
            <button onClick={onClose} className="btn btn-primary" style={{ marginRight: 10, }}>Cancel</button>
            <button

              onClick={() => {

                var data = new FormData();

                data.append('item_id', itemId);
                data.append('keyword', 'remove_inner_cat_product');
                data.append('inner_category_id', props.id)

                var config = {
                  method: 'patch',
                  url: url + '/items/details/',
                  headers: {
                    'Authorization': getToken(),
                  },
                  data: data
                };

                axios(config)
                  .then(function (response) {
                    if (response.data.Status == true) {
                      showMessage("Product removed from menu", "success", "Success!", 'top', 'top-right', 0)
                      setMenuUpdate(!menuUpdate)
                      onClose()
                    } else {
                      showMessage("Menu update failed", "danger", "Error!", 'top', 'top-right', 0)
                      onClose()
                    }
                  })
                  .catch(function (error) {
                    showMessage("Menu update failed", "danger", "Error!", 'top', 'top-right', 0)
                    onClose()
                  });

              }}
              className="btn btn-primary"
            >
              Remove
        </button>
          </div>
        );
      }
    });


  }

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0
      );
    }
  }, [errors]);

  return (


    <div class="content-body">
      <div class="container-fluid">
        {
          !loading ?
            <>
              {
                !noCat ?
                  <>
                    {<EditTopComponent

                      BackButtonPath={"/menu/"}
                      DeleteButton={(e) => {
                        e.preventDefault();
                        // if (window.confirm("Are You sure")) {
                        //   let res = ManageCategory(
                        //     e,
                        //     data,
                        //     "delete",
                        //     `id=${data.id}`
                        //   );
                        //   res.then((res) => {
                        //     if (res) {
                        //       alert("Success");
                        //       window.location.replace("/categories");
                        //     } else {
                        //       alert("Error");
                        //     }
                        //   });

                        // }
                        confirmAlert({
                          customUI: ({ onClose }) => {
                            return (
                              <div className='custom-ui' style={{ borderRadius: 8, border: 'solid', padding: 70, borderWidth: 0.5 }}>
                                <h1>Are you sure?</h1>
                                <p>You want to delete ?</p>
                                <button onClick={onClose} className="btn btn-primary" style={{ marginRight: 10, }}>Cancel</button>
                                <button

                                  onClick={() => {
                                    // let res = ManageCategory(
                                    //   e,
                                    //   data,
                                    //   "delete",
                                    //   `id=${data.id}`
                                    // );
                                    let res = ManageInnerCategory(
                                      e,
                                      data,
                                      "delete",
                                      `id=${data.id}`
                                    );
                                    res.then((res) => {
                                      if (res) {
                                        showMessage("Delete success", "success", "Success!", "top", "top-right")
                                        window.location.replace("/menu");
                                      } else {
                                        showMessage("delete failed", "danger", "Failed!", "top", "top-right")
                                      }
                                    }).catch(err => {
                                      showMessage(res.data.Error, "danger", "Error!", "top", "top-right")
                                    })
                                  }}
                                  className="btn btn-primary"
                                >
                                  Delete
                            </button>
                              </div>
                            );
                          }
                        });

                      }}
                      AddButtonName={"Add Menu"}
                      AddButtonPath={"/addMenu"}
                      CancelButton={(e) => {
                        e.preventDefault();
                        setEdit(false);
                        // void 0
                      }}
                      EditButton={
                        (e) => {
                          e.preventDefault();
                          setEdit(true);
                          // void 0
                        }
                      }
                      Edit={Edit}
                    />}
                    <div className="col-xl-12 col-lg-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="basic-form">
                            <form>
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Menu Name{" "}
                                  <span className="required">*</span>
                                </label>
                                <div className="col-sm-9">
                                  {!Edit ?
                                    <label className="col-sm-3 col-form-label">
                                      {data.name}
                                    </label>
                                    :
                                    <input
                                      type="text"
                                      className="form-control"
                                      // readOnly={Edit}
                                      disabled={!Edit}
                                      value={data.name}
                                      onChange={(e) =>
                                        setData({ ...data, name: e.target.value })
                                      }
                                    />
                                  }
                                </div>
                              </div>

                              {/* <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Active</label>

                                <div className="col-sm-2 ">
                                  <div className="custom-control custom-checkbox mb-3">
                                    <input
                                      type="checkbox"
                                      checked={data.is_active}
                                      value={data.is_active}
                                      disabled={!Edit}
                                      onClick={(e) =>
                                        setData({ ...data, is_active: e.target.checked })
                                      }
                                      className="custom-control-input"
                                      id="customCheckBox1"
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="customCheckBox1"
                                    >
                                      Active
                          </label>
                                  </div>
                                </div>
                              </div>
 */}
 

                              {/* <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Is Menu</label>

                                <div className="col-sm-2 ">
                                  <div className="custom-control custom-checkbox mb-3">
                                    <input
                                      type="checkbox"
                                      checked={data.inner_category}
                                      value={data.inner_category}
                                      disabled={!Edit}
                                      onClick={(e) =>
                                        setData({ ...data, inner_category: e.target.checked })
                                      }
                                      className="custom-control-input"
                                      id="customCheckBox2"
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="customCheckBox2"
                                    >
                                      Active
                          </label>
                                  </div>
                                </div>
                              </div> */}





                              {/* {!Edit ? (
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Icon {" "}<span className="required">*</span></label>
                                  <div className="col-sm-9">
                                    <img
                                      className="img-fluid rounded mr-3"
                                      width={85}
                                      src={data.icon}
                                      alt="Foodoor"
                                    />
                                  </div>
                                </div>
                              )
                                :
                                (
                                  <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Icon <span className="required">*</span></label>
                                 
                                 //   <span className="input-group-text">Upload</span>

                                    <div className="col-sm-9">
                                      <input
                                        type="file"
                                        className=" form-control custom-file-input"
                                        // value={data.background}
                                        onChange={(e) =>
                                          setData({ ...data, icon: e.target.files[0] })
                                        }
                                      />
                                      <label className="custom-file-label">
                                        Choose an icon
                          </label>
                                    </div>
                                  </div>
                                )} */}


                              {Edit && (

                                <EditBottomComponent
                                  type={props.id == "add" ? "add" : ""}
                                  cancelButton={(e) => {
                                    e.preventDefault();
                                    setEdit(false);

                                    // void 0
                                  }}
                                  saveButton={(e) => {
                                    e.preventDefault();

                                    setErrors([]);
                                    if (data.name === "") {
                                      setErrors(["Category name"]);
                                      return;
                                    }
                                    // void 0

                                    // let res = ManageCategory(e, data, "update");
                                    let res = ManageInnerCategory(e, data, "update");
                                    res.then((res) => {
                                      // void 0

                                      if (res.data.Status === true) {
                                        showMessage(
                                          "Category updated",
                                          "success",
                                          "Success!",
                                          "top",
                                          "top-right",
                                          0
                                        );
                                        // setEdit(true);
                                        setEdit(false);

                                      } else {
                                        showMessage(res.data.Error, "danger", "Failed!", "top", "top-right", 0);
                                      }
                                    });
                                  }}
                                />
                              )}
                            </form>
                          </div>
                        </div>
                        {/* <div className="d-sm-flex mb-lg-4 mb-2">
                      <div className="mt-4" className="text-left">
                        <a href onClick={() => { window.history.back() }} className="btn btn-primary mb-1 mr-1"> Back </a>
                      </div>
                    </div> */}
                        <hr />
                        <div className="d-sm-flex mb-lg-4 mb-2" style={{ justifyContent: 'flex-end' }}>
                          <div className="mt-4" className="text-left">
                            <a href data-toggle="modal" data-target="#filter" onClick={() => { }} className="btn btn-primary mb-1 mr-1" style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                              <div>
                                Filter
                          </div>

                              <span style={{ marginLeft: 10, fontSize: 20 }}><i class="fa fa-filter" aria-hidden="true"></i></span>
                            </a>
                          </div>
                          <div className="mt-4" className="text-left">
                            <a href data-toggle="modal" data-target="#sendMessageModal" onClick={() => { }} className="btn btn-primary mb-1 mr-1" style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                              <div>
                                Add Product
                          </div>

                              <span style={{ marginLeft: 10, fontSize: 20 }}><i class="fa fa-plus-circle" aria-hidden="true"></i></span>
                            </a>
                          </div>

                        </div>
                        {/* <div style={{display: 'flex',  alignItems: 'center', textAlign: 'center'}}>
                         <div>
                          Add Product
                          </div>
                           
                          <span style={{marginLeft: 10, fontSize: 20}}><i class="fa fa-plus-circle" aria-hidden="true"></i></span>
                        </div> */}
                      </div>

                      <div className="card">
                        <div className="row">
                          {(next || prev) && <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', marginRight: 20, marginBottom: 10 }}>
                            <button disabled={prev == null ? true : false} onClick={handlePrev} style={{ cursor: !prev ? 'default' : "pointer", backgroundColor: !prev ? 'gray' : "#3fb049", color: 'white', border: 'none', paddingLeft: 10, paddingRight: 10, borderRadius: 8 }}>
                              prev
                          </button>
                            <button disabled={next == null ? true : false} onClick={handleNext} style={{ marginLeft: 20, cursor: !next ? 'default' : "pointer", backgroundColor: !next ? 'gray' : "#3fb049", color: 'white', border: 'none', padding: 10, paddingLeft: 10, paddingRight: 10, borderRadius: 8 }}>
                              next
                          </button>
                          </div>}
                          {products.map((item, index) => {
                            let data_image =
                              "https://static.thenounproject.com/png/2879926-200.png";
                            if (item.icon) {
                              data_image = item.icon.image;
                            }

                            return (
                              <div id={item.id} className="col-lg-4 ">
                                <div className="mb-4 align-items-center menu-card-inner">
                                  {/* <a href={`/menuID/${item.id}`} style={{  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                                      {" "}
                                      <img
                                        className="rounded mr-3 food-img"
                                        height="110"
                                        src={""}
                                        alt
                                      />  
                                      <div><b style={{fontSize: 13, color: 'black', position: 'absolute', bottom: 43, left: 62}}>Menu</b></div>
                                    </a> */}
                                  <div className="media-body text-black" style={{ padding: 10, display: 'flex', alignItems: 'center', textAlign: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ cursor: 'pointer', textAlign: 'left' }}>
                                      <b >{item.name.charAt(0).toUpperCase() + item.name.slice(1)}</b><br />
                                      <b style={{ fontSize: 14 }}>Restaurant : {item.branch.name}</b>
                                    </div>
                                    <div><span onClick={() => removeProduct(item.id)} style={{ cursor: 'pointer' }}><i class="fa fa-times" aria-hidden="true"></i></span></div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          {products.length == 0 &&
                            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <h3>No products</h3>
                            </div>
                          }
                          {" "}
                        </div>
                      </div>
                    </div>
                  </>
                  :
                  <NoDataComponent data="Category" />}
            </>
            :

            <LoadingComponent />
        }
      </div>
      <div
        className="modal fade"
        id="sendMessageModal"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="card-header">
              <h4 className="card-title">
                <>{"Add"} Product</>
              </h4>
              <span data-dismiss="modal" style={{ cursor: 'pointer' }}><i class="fa fa-times" aria-hidden="true"></i></span>
            </div>

            <div className="modal-body">
              <form className="comment-form">


                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="text-black font-w600">
                        Branch <span className="required"></span>
                      </label>
                      <select
                        // value={filter.category_id}
                        class="form-control form-control-lg  "
                        onChange={(e) =>
                          setAddfilter({
                            ...addFilter,
                            branch_id: e.target.value,
                          })

                        }
                      >
                        <option value={""} id={""}>
                          All
                  </option>
                        {branch.map((item) => (
                          <option value={item.id} id={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div style={{ height: 80, width: '100%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', textAlign: 'center' }}>
                    <input value={addFilter.search_text} onChange={e => setAddfilter({ ...addFilter, search_text: e.target.value, search_id: "" })} placeholder="Enter product name" style={{ width: '60%', height: 40, paddingLeft: 10, borderRadius: 8, border: '1px solid green' }}>
                    </input>
                    <input value={addFilter.search_id} onChange={e => setAddfilter({ ...addFilter, search_id: e.target.value, search_text: "" })} placeholder="Product ID" style={{ width: '22%', height: 40, paddingLeft: 10, borderRadius: 8, border: '1px solid green' }}>
                    </input>
                    <div onClick={handleSearch} style={{ cursor: 'pointer', color: 'white', width: 40, height: 40, backgroundColor: '#3fb049', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                  </div>

                </div>

              </form>
              {(addProductNext || addProductPrev) && <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', marginBottom: 10 }}>
                <button disabled={addProductPrev == null ? true : false} onClick={handleProductPrev} style={{ cursor: !addProductPrev ? 'default' : "pointer", backgroundColor: !addProductPrev ? 'gray' : "#3fb049", color: 'white', border: 'none', paddingLeft: 10, paddingRight: 10, borderRadius: 8 }}>
                  prev
                </button>
                <button disabled={addProductNext == null ? true : false} onClick={handleProductNext} style={{ cursor: !addProductNext ? 'default' : "pointer", backgroundColor: !addProductNext ? 'gray' : "#3fb049", color: 'white', border: 'none', paddingLeft: 10, paddingRight: 10, borderRadius: 8 }}>
                  next
                </button>
              </div>}
              <div>
                {allProducts.map(item => (
                  <div style={{ borderRadius: 8, display: 'flex', width: '100%', justifyContent: 'space-between', border: '1px solid', marginBottom: 10, padding: 5, alignItems: 'center', textAlign: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', fontSize: 18 }}>
                      <b>{item.name}</b>
                    </div>
                    <div><span onClick={() => { addProduct(item.id); }} style={{ fontSize: 25, cursor: 'pointer' }}>+</span></div>
                  </div>
                ))}
                {allProducts.length == 0 &&
                  <div style={{ borderRadius: 8, display: 'flex', width: '100%', justifyContent: 'space-between', marginBottom: 10, padding: 5, alignItems: 'center', textAlign: 'center' }}>
                    <h3>No products</h3>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="filter"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="card-header">
              <h4 className="card-title">
                <>Filter</>
              </h4>
              <span data-dismiss="modal" style={{ cursor: 'pointer' }}><i class="fa fa-times" aria-hidden="true"></i></span>
            </div>

            <div className="modal-body">
              <form className="comment-form">


                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="text-black font-w600">
                        Branch <span className="required"></span>
                      </label>
                      <select
                        // value={filter.category_id}
                        class="form-control form-control-lg  "
                        onChange={(e) =>
                          setfilter({
                            ...filter,
                            branch_id: e.target.value,
                          })

                        }
                      >
                        <option value={""} id={""}>
                          All
                  </option>
                        {branch.map((item) => (
                          <option value={item.id} id={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div style={{ height: 80, width: '100%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', textAlign: 'center' }}>
                    <input value={filter.search_text} onChange={e => setfilter({ ...filter, search_text: e.target.value, search_id: "" })} placeholder="Enter product name" style={{ width: '50%', height: 40, paddingLeft: 10, borderRadius: 8, border: '1px solid green' }}>
                    </input>
                    <input value={filter.search_id} onChange={e => setfilter({ ...filter, search_id: e.target.value, search_text: "" })} placeholder="Product ID" style={{ width: '22%', height: 40, paddingLeft: 10, borderRadius: 8, border: '1px solid green' }}>
                    </input>
                    <div onClick={handleSearchProducts} style={{ cursor: 'pointer', color: 'white', width: 40, height: 40, backgroundColor: '#3fb049', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                      <i class="fa fa-search" aria-hidden="true" data-dismiss="modal"></i>
                    </div>
                    <div onClick={() => { clearSearchProducts() }} style={{ cursor: 'pointer', color: 'white', width: 40, height: 40, backgroundColor: '#3fb049', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                      <i class="fa fa-times" aria-hidden="true" data-dismiss="modal"></i>
                    </div>
                  </div>

                </div>

              </form>

              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
}

function CategoryID() {


  const { id } = useParams();
  // void 0
  const headers = "Menu Details";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body id={id} />
        <Footer />
      </div>
    </div>
  );
}

export default CategoryID;
